import { DEFAULT_EXECUTIVE_PERSON, executivePersonMainReferenceType, executiveRoleId } from "@/constants/executivePerson";
import { Contract, Process } from "@/types/contract";
import { ExecutivePersonFormValues, ExecutivePeopleFormValues } from "./form";
import { FileTypeCode } from "@/constants/attachment";

export const createExecutivePeopleInitialValues = (contract: Contract, czechCountryId: string): ExecutivePeopleFormValues => {
  const mainPersonId = contract.executivePeople.find(e => e.referenceType === executivePersonMainReferenceType)?.id;

  const newExecutivePerson: ExecutivePersonFormValues = {
    ...DEFAULT_EXECUTIVE_PERSON,
    id: "",
    name: "",
    surname: "",
    degreeBeforeId: "",
    degreeAfterId: "",
    email: "",
    mobilePhone: "",
    mobileCountryCode: czechCountryId,
    executiveRoleId: contract.process === Process.MOBILITY_SERVICES ? executiveRoleId : "",
    birthDate: null,
    editable: true,
    referenceType: null,
  };

  const executivePople = contract.executivePeople.map(e => ({
    id: e.id,
    name: e.name,
    surname: e.surname,
    degreeBeforeId: e.degreeBeforeId,
    degreeBeforeId2: e.degreeBeforeId2,
    degreeAfterId: e.degreeAfterId,
    email: e.email,
    mobilePhone: e.mobilePhone,
    mobileCountryCode: czechCountryId,
    executiveRoleId: e.editable === false && !e.executiveRoleId ? executiveRoleId : e.executiveRoleId,
    birthDate: e.birthDate,
    editable: e.editable,
    referenceType: e.referenceType,
  }));

  return {
    currentPersonId: mainPersonId ?? "",
    executivePeople: [...executivePople, newExecutivePerson],
    uploaded:
      contract.attachments.filter(a => a.fileTypeCode === FileTypeCode.CAP && a.groupId === 3).length !== 0
        ? "uploaded"
        : "noFiles",
  };
};
